module.exports = __webpack_public_path__ + "img/kommune-1002.4718d0ca.svg";